import { getNumericMetric } from '@utils/metrics/rateMetrics';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useAtomValue } from 'jotai';
import { metricSelector, selectedMetricSelector } from '@store/metricsChartContainer/selectors';
import { diagnosticsModeAtom, errorDataAtom } from '@components/metrics-panel-hz/atoms';
import { globalOrderBySelector } from '@store/trends/base/selectors';
import { getPercentageMetricByKey } from '@utils/metrics/metricHelpers';

function useExportMetrics() {
  const diagMode = useAtomValue(diagnosticsModeAtom);
  const selectedMetric = useSelector(selectedMetricSelector);
  const metrics = useSelector(metricSelector);
  const orderByMetric = useSelector(globalOrderBySelector);
  const errorData = useAtomValue(errorDataAtom);

  const exportMetrics = useMemo(() => {
    // list of visible metrics
    // filter out invalid metrics
    let baseMetrics = [...metrics].filter((m) => !errorData[m]);
    if (diagMode) {
      baseMetrics = [selectedMetric];
      if (selectedMetric !== orderByMetric) {
        baseMetrics.push(orderByMetric);
      }
    }

    const exportMetrics: string[] = [];
    baseMetrics.forEach((m) => {
      exportMetrics.push(m, getNumericMetric(m));
      const percentageMetric = getPercentageMetricByKey({ metricKey: m });
      if (percentageMetric) {
        exportMetrics.push(percentageMetric);
      }
    });

    return [...new Set(exportMetrics)];
  }, [selectedMetric, diagMode, metrics, orderByMetric, errorData]);

  return exportMetrics;
}

export default useExportMetrics;
